var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlay" }, [
    _c("div", { staticClass: "overlay__wrapper" }, [
      _c("div", { staticClass: "overlay__content" }, [
        _c(
          "ul",
          {
            staticClass: "modal__content-list modal__content-list--error",
            attrs: { id: "modal-content" }
          },
          [
            _c(
              "li",
              { staticClass: "modal__content-item modal__content-item--title" },
              [
                _c("span", { staticClass: "modal__title" }, [
                  _c("i", { staticClass: "icofont-exclamation-tringle" }),
                  _vm._v(" " + _vm._s(_vm.error.title) + "\n          ")
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "modal__close modal-close-action",
                  on: { click: _vm.closeErrorModal }
                })
              ]
            ),
            _vm._v(" "),
            _c("li", { staticClass: "modal__content-item modal__control" }, [
              _c("p", { staticClass: "modal__control_header" }, [
                _vm._v(_vm._s(_vm.error.header))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "modal__control_text" }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.error.message) + "\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal__control_action" }, [
                _c("p", { staticClass: "modal__control_actionwrapper" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "modal__control_cancel modal-close-action modal__error-button",
                      on: { click: _vm.closeErrorModal }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.error.button) +
                          "\n              "
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }